import $ from "jquery";
import selectFields from "./selectFields";
import removeItemSummary from "./removeItemSummary";
import saveProductSummary from "./saveProductSummary";
import {Modal} from "bootstrap";
import eventListener from "./eventListener";
import userModal from "./userModal";
import backButton from "./backButton";
import alertElica from "./alert";

export default function () {
    if (!$('body').hasClass('summary')) {
        return false;
    }
    backButton();

    window.$registrationData = null;

    updatePage();

    $.ajax({
        url: loadRegistrationDataUrl,
        method: "POST",
        success: function (result) {
            window.$registrationData = result;
        }
    });

    userModal();
    product();
    fileUpload();
    removeItemSummary();
    saveProductSummary();
    eventListener();

    let confirmed = false;
    $("#confirm_continue").click(function () {
        if (confirmed) {
            return false;
        }

        if ($("input[name='informativa']").length) {
            $("input[name='informativa']").removeClass('is-invalid').parent().children('#validationInformativaFeedback').remove();
            $("input[name='termini']").removeClass('is-invalid').parent().children('#validationTerminiFeedback').remove();
            let submit = true;
            if (!$("input[name='informativa']").is(':checked')) {
                $("input[name='informativa']").addClass('is-invalid').next().after(
                    '<div id="validationInformativaFeedback" class="invalid-feedback" style="flex-basis: 100%;">' +
                    translations.acceptPrivacy +
                    '</div>'
                );
                submit = false;
            }
            if (!$("input[name='termini']").is(':checked')) {
                $("input[name='termini']").addClass('is-invalid').next().after(
                    '<div id="validationTerminiFeedback" class="invalid-feedback" style="flex-basis: 100%;">' +
                    translations.acceptTerms +
                    '</div>'
                );
                submit = false;
            }
            if (!submit) {
                return false;
            }
        }

        let data = new FormData();
        let inputElements = $("#products_form").find("input,select,textarea").serializeArray();
        console.log(inputElements);
        for (var key in inputElements) {
            data.append(inputElements[key].name, inputElements[key].value);
        }

        $.ajax({
            url: saveToDatabaseUrl,
            method: "POST",
            data: data,
            processData: false,
            contentType: false,
            success: function (result) {
                confirmed = true;
                const myModal = new Modal('#loadingModal');
                myModal.show();
                checkRegistration(result.id);
            },
            error: function () {
                let response = JSON.parse(xhr.responseText);
                if (typeof response['error'] !== "undefined") {
                    alertElica(response['message']);
                    window.location.href = homeUrl;
                }
            }
        });
    });
}

export function updatePage() {
    $.ajax({
        url: loadSummaryUrl,
        method: "POST",
        success: function (result) {
            $("#loading").replaceWith('<div id="summary-data">' + result + '</div>');
        },
        error: function () {
            window.location.href = window.homeUrl;
        }
    });
}

function checkRegistration(id) {
    setTimeout(function () {
        $.ajax({
            url: checkProcessEndingUrl,
            method: "POST",
            data: {
                id: id
            },
            success: function (result) {
                if (result.generated) {
                    window.location.href = warrantyConfirmationUrl.replace("#id#", result.uuid);
                    return;
                }

                checkRegistration(id);
            }
        });
    }, 5000);
}

function product() {
    document.querySelector('#productAccordionItemModal').addEventListener('show.bs.modal', (e) => {
        let id = $(e.relatedTarget).data("id");
        let $body = $(e.target).find('.modal-body');
        $body.find('input:not(:checkbox):not(:radio):not(:file)').each(function () {
            $(this).val(window.$registrationData.products[id][$(this).data('name')]);
        });
        $body.find('select').each(function () {
            let value = window.$registrationData.products[id][$(this).data('name')];
            if (value === null) {
                value = "";
            }
            $(this).html('<option value="' + value + '" selected>' + value + '</option>');
            $(this).change().trigger('select2:select');
        });
        $body.find('input[data-name=category][value=' + window.$registrationData.products[id].category + ']').prop('checked', true);
        const fileChosen = $body.find('input[data-name=receipt]').parent().find('#file-chosen').get(0);
        fileChosen.innerHTML = '<a href="' + imageBaseUrl + window.$registrationData.products[id].receipt + '" target="_blank">' + window.$registrationData.products[id].receipt + '</a>';
        fileChosen.classList.add('uploaded');
        $body.find('.accordion-collapse').data("id", id);
        selectFields();
    })
}

function fileUpload() {
    $('body').on('change', 'input[data-name=receipt]', function () {
        const fileChosen = $(this).parent().find('#file-chosen').get(0);
        // Check filesize greater than 5Mb
        if (this.files[0].size > 5242880) {
            this.value = null;
            fileChosen.innerHTML = `<label class="alert alert-danger">${$('#validation-filesize-message').text()}</label>`;
        } else {
            fileChosen.textContent = this.files[0] ? this.files[0].name : "";
            fileChosen.classList.add('uploaded');
        }
    })
}
